import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import CreateRecordButtonLayout from "../layout/CreateRecordButtonLayout";
import TkPopQCDialog from "../dialogTypes/TkPopQCDialog";
import getSchema from "../../lib/api/getSchema";

function TkPopQCButton(props) {

    const { t } = useTranslation();

    const { id, refresh, onSuccess, createButtonName, customizeErrorMsgCallback, onSelectMst, onTrigger, ...others } = props;

    const [open, setOpen] = useState(false);

    const [schema, setSchema] = useState();

    useEffect(() => {

        let mounted = true;

        ( async ()=>{

            let schema = await getSchema("TkPopProductManageDetail");

            if ( mounted ) {

                for (const column of schema.columns) {
    
                    switch (column.name) {
        
                    case "fitQty":
                    case "failQty":
                    case "tester":
                    case "testResults":
                    case "wareHouseCode":
                    case "workTime":
                    case "testResultsDoc":
        
                        column.hideInForm = false;
        
                        break;
        
                    default:

                        column.hideInForm = true;
        
                        break;
                    }
                }

                setSchema(schema);

            }

        } ) ();

        return ( () => {

                mounted = false;

        } );

    }, [open]);

    const onOpen = () => {

        setOpen(true);
        onTrigger(true);

    };

    const onClose = () => {

        setOpen(false);
        onTrigger(false)
    };

    const onCreateSuccess = (msg) => {

        if (onSuccess) {

            onSuccess(msg);

        }

    };

    const modifyUrlCallback = (url) => {

        return `/api/TkPopProductManage/`;

    }

    return (

        <>
            <CreateRecordButtonLayout id={id + "create-button"} onClick={onOpen} createButtonName={createButtonName} {...others} />
            <TkPopQCDialog
                id={id + "create-dialog"}
                mode="create"
                formId={id + "create-form"}
                title={t(`dialog.title.Produce.qc`)}
                schema={schema}
                initialData={undefined}
                open={open}
                onClose={onClose}
                onSuccess={onCreateSuccess}
                customizeErrorMsgCallback={customizeErrorMsgCallback}
                modifyUrlCallback={modifyUrlCallback}
                onSelectMst={onSelectMst}
                noKeepOpen={true}
            />
        </>

    );
}

export default TkPopQCButton;